/**
 * Winter snowdrift backdrop: layered SVG mounds pinned to the bottom of the
 * viewport, behind all content (so opaque cards stay readable). Pairs with the
 * winter gradient (theme CSS) and the idle snow. Static + `pointer-events:none`.
 * Fills come from theme vars (`--drift-front`/`--drift-back`) so it adapts to
 * light/dark.
 */
import React from 'react';

import { Z } from '@shared/constants/zIndex';

/** Fixed snowdrift backdrop along the bottom edge of the viewport. */
export const WinterBackdrop: React.FC = () => (
  <div
    aria-hidden
    data-testid="winter-backdrop"
    className="pointer-events-none fixed inset-x-0 bottom-0 h-[22vh] max-h-56"
    style={{ zIndex: Z.BACKDROP }}
  >
    <svg viewBox="0 0 1440 220" preserveAspectRatio="none" className="h-full w-full">
      <path
        d="M0,120 Q240,60 480,100 T960,90 T1440,105 V220 H0 Z"
        fill="var(--drift-back)"
        opacity="0.6"
      />
      <path
        d="M0,150 Q300,95 640,135 T1440,130 V220 H0 Z"
        fill="var(--drift-front)"
        opacity="0.95"
      />
    </svg>
  </div>
);
